export enum PaymentStatus {
  PENDING = "pending",
  PAID = "paid",
  FAILED = "failed",
}

export enum PaymentType {
  SESSION = "session",
  INTENT = "intent",
}
